import { Component, inject, Input, input, OnInit } from '@angular/core';

import { take } from 'rxjs/operators';

import { UntilDestroy } from '@ngneat/until-destroy';
import { IError } from '@orgacard/login';

import { AppService } from '../../../../app.service';
import { CoreService } from '../../../../core/core.service';
import { EnvironmentService } from '../../../../core/environment.service';
import { ImageService } from '../../../../core/services/image.service';
import { UtilityHelperService } from '../../../../core/utility-helper.service';
import { LoadingOverlayService } from '../../../../loading-overlay/loading-overlay.service';
import { StateEnum } from '../../../shared/models/basic.model';
import { ISupplierContact, ISupplierContractCostcenterCustomer, ISupplierDiscount, ISupplierStatus } from '../../shared/models/supplier.model';
import { SupplierService } from '../../shared/services/supplier.service';

@UntilDestroy()
@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    standalone: false,
})
export class CardComponent implements OnInit {
    private readonly utilityHelperService = inject(UtilityHelperService);
    readonly supplierService = inject(SupplierService);
    readonly environmentService = inject(EnvironmentService);
    readonly coreService = inject(CoreService);
    private readonly appService = inject(AppService);
    private readonly imageService = inject(ImageService);
    private readonly loadingOverlayService = inject(LoadingOverlayService);

    public readonly supplierContacts = input<ISupplierContact[]>(undefined);
    @Input() public supplierContractCostcenterStatus: ISupplierStatus;
    public readonly actualCostcenterInfo = input<string>(undefined);
    @Input() public actualSupplierContractCostcenterCustomer: ISupplierContractCostcenterCustomer;

    public discountDataSource: ISupplierDiscount[] = [];

    public displayedColumnsConditions: string[] = ['desc', 'value', 'unit'];
    public discountDisplayedColumns: string[] = ['typedescr', 'conditionValue', 'discountValue'];

    public stateEnum = StateEnum;

    public get imagePath() {
        return (
            this.imageService.getImageUrl({ imageId: this.supplierService.supplierBasedata.imageId, imageFilename: undefined }) +
            this.supplierService.supplierBasedata.imageId
        );
    }

    public ngOnInit() {
        this.setUpCustomerListenerEvent();
    }

    public setUpCustomerListenerEvent() {
        if (this.supplierService.method === 'EDIT') {
            this.loadingOverlayService.startLoading();
            //
            this.supplierService
                .getCustomerChangeNotification()
                .pipe(take(1))
                .subscribe(
                    (customer) => {
                        if (this.environmentService.appSettings.showLog)
                            console.log(new Date() + ': ' + 'card.component.ts - setUpCustomerListenerEvent ---> RESPONSE data: ' + customer);

                        this.supplierService
                            .getContractDetailByContractId(this.supplierService.supplierContract.id)
                            .pipe(take(1))
                            .subscribe(
                                (response) => {
                                    if (this.environmentService.appSettings.showLog)
                                        console.log(new Date() + ': ' + 'card.component.ts - getContractDetailByContractId ---> RESPONSE data: ' + response);
                                    this.discountDataSource = this.supplierService.supplierContractDetail.supplierDiscounts;

                                    this.loadingOverlayService.stopLoading();
                                },
                                (err: IError) => {
                                    this.utilityHelperService.handleComponentError(err);
                                },
                            );
                    },
                    (err: IError) => {
                        this.utilityHelperService.handleComponentError(err);
                    },
                );
        }
    }
}
